import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";

export function useRecentCharacterQuery() {
  const { access, session } = useAppContext();
  return useQuery({
    queryKey: ["recent-characters", session?.user?.id],
    queryFn: async () => {
      return await access.character.getRecents();
    }
  });
}
